<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Chapter-Title-Page-Break" id="_idParaDest-2"><a id="_idTextAnchor001"></a>POST SCRIPTUM</p>
<p class="ORIM-Chapter-Opener-Paragraph">Now, in 1907, on the occasion of the issue of this edition, I can only add how glad I am that my romance should continue to please so many readers. Imagination has been verified by fact; the King Solomon’s Mines I dreamed of have been discovered, and are putting out their gold once more, and, according to the latest reports, their diamonds also; the Kukuanas or, rather, the Matabele, have been tamed by the white man’s bullets, but still there seem to be many who find pleasure in these simple pages. That they may continue so to do, even to the third and fourth generation, or perhaps longer still, would, I am sure, be the hope of our old and departed friend, Allan Quatermain.</p>
<p class="ORIM-Body-Text-Right">H. Rider Haggard.</p>
<p class="ORIM-Body-Text-Right">Ditchingham, 1907.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled13.vue?a21e4b96